import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import * as Constants from '../constants'
import * as actions from '../actions/micustomeractions'
import * as appConstants from '../../../overrides/appconstants'
import * as appUtility from '../../../infrastructure/apputilityfunctions'

export default function MedicalApplicationForm() {

    const { register: registerShortMedicalForm, handleSubmit: handleSubmitShortMedicalForm,
        reset: resetShortMedicalForm, setValue: setMafValues, watch: watchShortMedicalForm, formState: { errors: errorsShortMedicalForm } } = useForm();
    const { register: registerFullMedicalForm, handleSubmit: handleSubmitFullMedicalForm,
        reset: resetFullMedicalForm, watch: watchFullMedicalForm, formState: { errors: errorsFullMedicalForm } } = useForm();

    const state = useSelector(state => state.miCustomerSharedReducer);
    const refShortQuestionaire = useRef(null);
    const refFullQuestionaire = useRef(null);
    let medicalApplicationForm = state?.medicalApplicationForm ?? {}
    let memberBasicInfo = state?.memberBasicInfo ?? {}
    var masters = state.masters;
    var mafAnswers = state.medicalApplicationForm?.mafAnswers;
    var mafDateAnswers = state.medicalApplicationForm?.mafDateAnswers;
    const memberList = state.memberBasicInfo?.memberList;
    var mafQuestions = medicalApplicationForm?.mafQuestions;
    var basicInfoNewEnq = state?.basicInfoNewEnq;
    let LMPApplList = memberList?.filter(memb => memb?.memberGender == Constants.FEMALE_DOMAIN_ID_ID && memb?.relation != appConstants.RELATION_CHILDREN_ID)?.map(membb => membb?.memberId)

    const dispatch = useDispatch();
    console.log('mafQuestions', mafQuestions);

    var mafQuestionsNotAppl = mafQuestions?.filter(p => p?.isApplicable == "N")?.map(y => y?.itemId)
    console.log('mainCheckNoToggle', mafQuestionsNotAppl);

    const scrollToFullQuestionaire = () => {
        refFullQuestionaire.current?.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToShortQuestionaire = () => {
        refShortQuestionaire.current?.scrollIntoView({ behavior: 'smooth' });
    };




    const handleMedicalFormChange = (e) => {
        let { name, value, checked } = e.target;
        var fieldName = name.match(/[a-zA-Z]+/g);
        var questionNo = name.match(/[0-9]+/g);
        if (fieldName == "mainCheckYes" || fieldName == "mainCheckNo") {
            dispatch(actions.updateMedicalFormParams({ name: questionNo, value: "Y" })); //for correct YN renering
            if (fieldName == "mainCheckNo"/*  checked == false */) {
                if (name?.slice(0, 2) != Constants.MAF_ITEM_ID_59) {
                    let mafAnswers = medicalApplicationForm?.mafAnswers
                        ? medicalApplicationForm.mafAnswers.map(answer => ({
                            ...answer,
                            memberIdList: [...answer.memberIdList],
                        }))
                        : [];
                    var delEle = mafAnswers?.find(p => p?.itemId == questionNo)
                    var index = mafAnswers?.indexOf(delEle)
                    if (index != -1) {
                        mafAnswers.splice(index, 1)


                        let childQuestionIdList = mafQuestions?.filter(g => g?.parentId == questionNo)?.map(ga => ga?.itemId)
                        let grandChildQuestionList = mafQuestions?.filter(g => (g?.parentId == questionNo || childQuestionIdList?.includes(g?.parentId)))?.map(ga => ga?.itemId)
                        let familyQuestionList = mafQuestions?.filter(g => (g?.parentId == questionNo || childQuestionIdList?.includes(g?.parentId) || grandChildQuestionList?.includes(g?.parentId)))?.map(ga => ga?.itemId)
                        mafAnswers = mafAnswers?.filter(xana => !familyQuestionList?.includes(xana?.itemId))


                        dispatch(actions.updateMAFInfo({ name: "mafAnswers", value: mafAnswers }));
                    }
                }
                else {
                    dispatch(actions.updateMAFInfo({ name: "isDateSelectedYn", value: null }));
                    dispatch(actions.updateMAFInfo({ name: "mafDateAnswers", value: [] }));

                    resetShortMedicalForm();
                }
            }
            else {
                if (name?.slice(0, 2) != Constants.MAF_ITEM_ID_59) {
                    let mafAnswers = medicalApplicationForm?.mafAnswers
                        ? medicalApplicationForm.mafAnswers.map(answer => ({
                            ...answer,
                            memberIdList: [...answer.memberIdList],
                        }))
                        : [];
                    var newEle = mafAnswers?.find(p => p?.itemId == questionNo)
                    if (newEle == null) {
                        newEle = {
                            itemId: questionNo[0],
                            isSelectedYn: "Y",
                            memberIdList: []
                        }
                        mafAnswers = [...mafAnswers, newEle]
                        dispatch(actions.updateMAFInfo({ name: "mafAnswers", value: mafAnswers }));
                    }
                    else {
                        if (newEle?.isSelectedYn != "Y") {
                            var indexTo = mafAnswers?.indexOf(newEle)
                            mafAnswers = [...mafAnswers.slice(0, indexTo), { ...newEle, isSelectedYn: "Y" }, ...mafAnswers.slice(indexTo, mafAnswers.length)]
                            dispatch(actions.updateMAFInfo({ name: "mafAnswers", value: mafAnswers }));
                        }
                    }
                }
                else {
                    dispatch(actions.updateMAFInfo({ name: "isDateSelectedYn", value: "Y" }));
                    // dispatch(actions.updateMAFInfo({ name: "mafDateAnswers", value: [] }));
                }
            }

        }
        else if (fieldName == "RemarkDate") {
            const splitIndexStart = name.indexOf("RemarkDate");
            const itemId = parseInt(name.slice(0, splitIndexStart), 10);
            const staticText = "RemarkDate";
            const srlNo = parseInt(name.slice(splitIndexStart + staticText.length), 10);

            var mafDateAnswers = [...medicalApplicationForm?.mafDateAnswers] ?? []

            if (value != null && value != "") {
                var answerInfo = { memberId: srlNo, date: value };
                // if (!mafDateAnswers?.map(x => x?.memberId).includes(srlNo)) {
                var dateObj = mafDateAnswers?.find(p => p?.memberId == srlNo)
                var dateObjIndex = mafDateAnswers?.indexOf(dateObj)
                mafDateAnswers = [...mafDateAnswers?.slice(0, dateObjIndex), answerInfo, ...mafDateAnswers?.slice(dateObjIndex + 1, mafDateAnswers?.length)];
                // }
            }
            else {
                mafDateAnswers = mafDateAnswers.filter(p => p?.memberId != srlNo);
            }

            dispatch(actions.updateMAFInfo({ name: "mafDateAnswers", value: mafDateAnswers }));
        }
    }


    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    const handleMedicalFormChangeAlt = (e, fieldName, questionNo, srlNo) => {
        let { name, value, checked } = e.target;

        if (fieldName == "memCheck") {
            const itemId = questionNo;

            let mafAnswers = medicalApplicationForm?.mafAnswers
                ? medicalApplicationForm.mafAnswers.map(answer => ({
                    ...answer,
                    memberIdList: [...answer.memberIdList],
                }))
                : [];

            let answerInfo = mafAnswers.find(p => p?.itemId == itemId);
            if (!answerInfo) {
                answerInfo = { itemId, isSelectedYn: "Y", memberIdList: [] };
                mafAnswers.push(answerInfo);
            }

            if (checked) {
                if (!answerInfo.memberIdList.includes(srlNo)) {
                    answerInfo.memberIdList = [...answerInfo.memberIdList, srlNo];
                }
            }
            else {
                answerInfo.memberIdList = answerInfo.memberIdList.filter(p => p != srlNo);

                let childQuestionIdList = mafQuestions?.filter(g => g?.parentId == itemId)?.map(ga => ga?.itemId)
                let familyQuestionList = mafQuestions?.filter(g => (g?.parentId == itemId || childQuestionIdList?.includes(g?.parentId)))?.map(ga => ga?.itemId)
                mafAnswers = mafAnswers?.map(xana => {
                    if (familyQuestionList?.includes(xana?.itemId)) {
                        return { ...xana, memberIdList: xana?.memberIdList?.filter(xanax => xanax != srlNo) }
                    }
                    else {
                        return { ...xana }
                    }
                })

            }

            if (answerInfo.memberIdList.length === 0) {
                // mafAnswers = mafAnswers.filter(answer => answer.itemId != itemId);
            }
            else {
                mafAnswers = mafAnswers.map(answer =>
                    answer.itemId == itemId ? { ...answerInfo } : answer
                );
            }

            dispatch(actions.updateMAFInfo({ name: "mafAnswers", value: mafAnswers }));
            console.log('medicalApplicationForm', medicalApplicationForm)

        }
        else if (fieldName == "subCheckYes" || fieldName == "subCheckNo") {
            const itemId = questionNo;
            const childQuestionIdList = mafQuestions?.filter(zyn => zyn?.parentId == itemId)?.map(xan => xan?.itemId)

            let mafAnswers = medicalApplicationForm?.mafAnswers
                ? medicalApplicationForm.mafAnswers.map(answer => ({
                    ...answer,
                    memberIdList: [...answer.memberIdList],
                }))
                : [];

            let answerInfo = mafAnswers.find(p => p?.itemId == itemId);
            if (!answerInfo) {
                answerInfo = { itemId, isSelectedYn: "Y", memberIdList: [] };
                mafAnswers.push(answerInfo);
            }

            if (fieldName == "subCheckYes") {
                if (!answerInfo.memberIdList.includes(srlNo)) {
                    answerInfo.memberIdList = [...answerInfo.memberIdList, srlNo];
                }
            }
            else {
                answerInfo.memberIdList = answerInfo.memberIdList.filter(p => p != srlNo);
                mafAnswers = mafAnswers?.map(xana => {
                    if (childQuestionIdList?.includes(xana?.itemId)) {
                        return { ...xana, memberIdList: xana?.memberIdList?.filter(xanax => xanax != srlNo) }
                    }
                    else {
                        return { ...xana }
                    }
                })

            }

            if (answerInfo.memberIdList.length === 0) {
                var delEle = mafAnswers?.find(p => p?.itemId == questionNo[0])
                var index = mafAnswers?.indexOf(delEle)
                if (index != -1) {
                    mafAnswers.splice(index, 1)
                    // dispatch(actions.updateMAFInfo({ name: "mafAnswers", value: mafAnswers }));
                }
            }
            else {
                mafAnswers = mafAnswers.map(answer =>
                    answer.itemId == itemId ? { ...answerInfo } : answer
                );
            }

            dispatch(actions.updateMAFInfo({ name: "mafAnswers", value: mafAnswers }));
            console.log('medicalApplicationForm', medicalApplicationForm)

        }
        else if (fieldName == "Radio") {
            const itemId = questionNo;

            let mafAnswers = medicalApplicationForm?.mafAnswers
                ? medicalApplicationForm.mafAnswers.map(answer => ({
                    ...answer,
                    memberIdList: [...answer.memberIdList],
                }))
                : [];

            let answerInfo = mafAnswers.find(p => p?.itemId == itemId);
            if (!answerInfo) {
                answerInfo = { itemId, isSelectedYn: "Y", memberIdList: [] };
                mafAnswers.push(answerInfo);
            }

            if (checked) {
                if (!answerInfo.memberIdList.includes(srlNo)) {
                    answerInfo.memberIdList = [...answerInfo.memberIdList, srlNo];
                }
            }
            else {
                answerInfo.memberIdList = answerInfo.memberIdList.filter(p => p != srlNo);
            }


            //removing other radio answers
            let parentId = mafQuestions?.find(g => g?.itemId == itemId)?.parentId;
            let remainingRadioQuestionsItemIdList = mafQuestions?.filter(g => g?.parentId == parentId && g?.itemId != itemId)?.map(que => que?.itemId)
            let remaingingRadioAnswersNew = mafAnswers?.filter(g => remainingRadioQuestionsItemIdList.includes(g?.itemId))?.map(answer => ({
                ...answer,
                memberIdList: [...answer.memberIdList?.filter(c => c != srlNo)],
            }))
            mafAnswers = mafAnswers?.map(finAns => {
                if (remainingRadioQuestionsItemIdList.includes(finAns?.itemId)) {
                    return ({ ...remaingingRadioAnswersNew?.find(z1 => finAns?.itemId == z1?.itemId) });
                }
                else {
                    return ({ ...finAns })
                }
            })
            mafAnswers = mafAnswers?.filter(nEMpt => nEMpt?.memberIdList?.length > 0 && !remainingRadioQuestionsItemIdList?.itemIdList?.includes(nEMpt?.itemId))
            dispatch(actions.updateMAFInfo({ name: "mafAnswers", value: mafAnswers }));
            console.log('medicalApplicationForm', medicalApplicationForm)

        }
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    const onSubmitMedicalForm = async (data, e) => {
        console.log(data);
        console.log(e)
        // await dispatch(actions.saveMedicalFormDetails());
        let checkReferral = false // await dispatch(miBrokerActions.getMemberDetails(1, null));
        if (checkReferral == true/*medicalApplicationForm.currentMemberMafReferral == "Referral" && medicalApplicationForm.currentMemberMafStatus == "Incomplete"*/) {
            scrollToFullQuestionaire();
        }
        else {
            scrollToShortQuestionaire();
        }
        // await dispatch(miBrokerActions.getQuoteReferralStatus());
    }
    const onResetFullMedicalForm = () => {
        resetFullMedicalForm();
        // dispatch(actions.resetFullMedicalFormParams());
    }
    const onResetShortMedicalForm = () => {
        //navigate('');
        resetShortMedicalForm();
        // dispatch(actions.resetShortMedicalFormParams());
    }

    const onErrorShortMedicalForm = (errorsShortMedicalForm, e) => {
        console.log(errorsShortMedicalForm, e)
    }
    function renderShortMedicalForm() {
        return (<>
            <ul className="nav nav-tabs nav-bordered mb-2">
            </ul>
            <div className={medicalApplicationForm.collapseShortQuestionaireClass} id="CollapseShortMedicalForm" >
                <form className="form-group needs-validation"
                    onSubmit={handleSubmitShortMedicalForm(onSubmitMedicalForm, onErrorShortMedicalForm)} noValidate="noValidate">


                    {/* <div className="row g-2">
                        <div className="mb-2 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <button type="button" className="btn btn-danger"
                                    data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetShortMedicalForm()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                            </div>
                        </div>
                    </div> */}

                    <div
                    /* data-bs-spy="scroll" data-bs-offset="0" className="scrollspy-example" style={{ height: '700px' }} */
                    >

                        {/*MAIN SHORT QUESTIONS*/}
                        {medicalApplicationForm.mafQuestions &&
                            medicalApplicationForm.mafQuestions.filter((e) => e.sectionId === Constants.MAF_SHORT_QUESTIONAIRE_ID && e.isSubItem === Constants.MAF_IS_SUB_ITEM_FLAG_N && ((/* medicalApplicationForm.currentMemberMaritalStatus === Constants.MARRIED_DOMAIN_ID && medicalApplicationForm.currentMemberGender === Constants.FEMALE_DOMAIN_ID */memberBasicInfo?.memberList?.some(p => p.memberGender == Constants.FEMALE_DOMAIN_ID_ID)) ? true : (e.itemId !== Constants.MAF_ITEM_ID_41 && e.itemId !== Constants.MAF_ITEM_ID_45 && e.itemId !== Constants.MAF_ITEM_ID_59)))
                                .map((mafQuestions/*, index*/) => (
                                    <div key={mafQuestions.itemId} >
                                        {/*MAIN SHORT QUESTIONS*/
                                            <div className="row g-2 mb-2">
                                                {mafQuestions?.itemId != Constants.MAF_ITEM_ID_59 && <>
                                                    <div className="col-md-10">
                                                        <h5> {mafQuestions.orderId}.&nbsp;&nbsp;{mafQuestions.questionsInEnglish}</h5>
                                                    </div>
                                                    <div className="col-md-1 align-self-center text-end">
                                                        <input disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued} type="checkbox" id={mafQuestions?.itemId + "mainCheckYes"}
                                                            name={mafQuestions?.itemId + "mainCheckYes"}
                                                            className="form-check-input"
                                                            checked={(mafAnswers?.find(p => p?.itemId == mafQuestions?.itemId)?.isSelectedYn == "Y" && mafQuestions?.itemId != Constants.MAF_ITEM_ID_59) || (medicalApplicationForm?.isDateSelectedYn == "Y" && mafQuestions?.itemId == Constants.MAF_ITEM_ID_59)}
                                                            {...registerShortMedicalForm(`${mafQuestions?.itemId}mainCheckYes`, { required: true, onChange: (e) => handleMedicalFormChange(e) })}
                                                        />
                                                        <label className="form-check-label ms-1" for={mafQuestions?.itemId + "mainCheckYes"}>Yes</label>
                                                    </div>
                                                    <div className="col-md-1 align-self-center text-end">
                                                        <input type="checkbox" id={mafQuestions?.itemId + "mainCheckNo"}
                                                            disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                            name={mafQuestions?.itemId + "mainCheckNo"}
                                                            className="form-check-input"
                                                            checked={(mafAnswers?.find(p => p?.itemId == mafQuestions?.itemId)?.isSelectedYn != "Y" && mafQuestions?.itemId != Constants.MAF_ITEM_ID_59) || (medicalApplicationForm?.isDateSelectedYn != "Y" && mafQuestions?.itemId == Constants.MAF_ITEM_ID_59)}
                                                            // checked={!mafQuestionsNotAppl?.includes(mafQuestions?.itemId) && mafAnswers?.find(p => p?.itemId == mafQuestions?.itemId)?.isSelectedYn != "Y"}
                                                            {...registerShortMedicalForm(`${mafQuestions?.itemId}mainCheckNo`, { required: true, onChange: (e) => handleMedicalFormChange(e) })}
                                                        />
                                                        <label className="form-check-label ms-1" for={mafQuestions?.itemId + "mainCheckNo"}>No</label>
                                                    </div>
                                                </>}

                                            </div>

                                        }
                                        {mafAnswers?.find(p => p?.itemId == mafQuestions?.itemId)?.isSelectedYn == "Y" && mafQuestions?.itemId != Constants.MAF_ITEM_ID_59 &&
                                            < div className="m-2 col-12 alert alert-primary fade show" >{memberBasicInfo?.memberList?.map((member, index) => (
                                                <>
                                                    {((mafQuestions?.itemId == Constants.MAF_ITEM_ID_41 || mafQuestions?.itemId == Constants.MAF_ITEM_ID_45 || mafQuestions?.itemId == Constants.MAF_ITEM_ID_59) ? member?.memberGender == Constants.FEMALE_DOMAIN_ID_ID : true) && <>
                                                        <div
                                                            className="row align-items-center mb-2"
                                                            onClick={() => document.getElementById(mafQuestions?.itemId + "memCheck" + member?.memberId).click()} // Simulates a click on the checkbox
                                                            style={{ cursor: 'pointer' }} // Changes the cursor to indicate clickability
                                                        >
                                                            <div className="col-md-1" id="Check1">
                                                                <input
                                                                    disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                                    type="checkbox"
                                                                    id={mafQuestions?.itemId + "memCheck" + member?.memberId}
                                                                    className="form-check-input"
                                                                    name={mafQuestions?.itemId + "memCheck" + member?.memberId}
                                                                    onChange={e => handleMedicalFormChangeAlt(e, "memCheck", mafQuestions?.itemId, member?.memberId)}
                                                                    checked={mafAnswers?.find(p => p?.itemId == mafQuestions?.itemId)?.memberIdList?.find(f => f == member?.memberId)}
                                                                    onClick={(e) => e.stopPropagation()} // Prevents the event from propagating when clicking the checkbox directly
                                                                />
                                                            </div>
                                                            <div className="col-md-8">{member?.memberFullName}</div>
                                                            <div className="col-md-3 text-end">{masters?.relationMasters?.find(p => p?.id == member?.relation)?.name ?? ""}</div>
                                                        </div>
                                                        {/*  */}


                                                        {/*SUB QUESTIONS*/
                                                            mafAnswers?.find(p => p?.itemId == mafQuestions?.itemId)?.memberIdList?.find(f => f == member?.memberId) && (medicalApplicationForm?.mafQuestions?.filter((e) => e.parentId === mafQuestions?.itemId && e.isSubItem === "Y").length != 0 ? true : false) &&
                                                            < div className="row g-2 mb-2">
                                                                < div className="m-2 col-11 alert alert-primary fade show" >
                                                                    {medicalApplicationForm.mafQuestions.filter((e) => e.parentId === mafQuestions.itemId && e.isSubItem === "Y").map((mafSubQuestions/*, index*/) => (
                                                                        <div key={mafSubQuestions.itemId} >
                                                                            <div className="row g-2 mb-2">
                                                                                <div className="col-md-6">
                                                                                    <h5> <i className='dripicons-question me-2'></i>{mafSubQuestions.questionsInEnglish}</h5>
                                                                                </div>
                                                                                <div className="col-md-2">
                                                                                </div>
                                                                                <div className="col-md-4">
                                                                                    <div className="row g-2">
                                                                                        <div className="form-check form-check-inline m-2 mt-3 col-md-3">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={mafSubQuestions?.itemId + "subCheckYes" + member?.memberId}
                                                                                                name={mafSubQuestions?.itemId + "subCheckYes" + member?.memberId}
                                                                                                value="Y"
                                                                                                className={errorsShortMedicalForm.hasOwnProperty(`${mafSubQuestions?.itemId + "subCheckYes" + member?.memberId}`) && mafSubQuestions.isApplicable === null ? 'form-check-input is-invalid' : 'form-check-input'}
                                                                                                checked={mafAnswers?.find(p => p?.itemId == mafSubQuestions?.itemId)?.memberIdList.find(v => v == member?.memberId)}
                                                                                                disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                                                                onChange={e => handleMedicalFormChangeAlt(e, "subCheckYes", mafSubQuestions?.itemId, member?.memberId)}
                                                                                            />
                                                                                            <label className="form-check-label " for={mafSubQuestions?.itemId + "subCheckYes" + member?.memberId}>Yes</label>
                                                                                        </div>
                                                                                        <div className="form-check form-check-inline m-2 mt-3 col-md-3">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={mafSubQuestions?.itemId + "subCheckNo" + member?.memberId}
                                                                                                name={mafSubQuestions?.itemId + "subCheckNo" + member?.memberId}
                                                                                                value="N"
                                                                                                className={errorsShortMedicalForm.hasOwnProperty(`${mafSubQuestions?.itemId + "subCheckNo" + member?.memberId}`) && mafSubQuestions.isApplicable === null ? 'form-check-input is-invalid' : 'form-check-input'}
                                                                                                checked={!mafAnswers?.find(p => p?.itemId == mafSubQuestions?.itemId)?.memberIdList.find(v => v == member?.memberId)}
                                                                                                disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                                                                onChange={e => handleMedicalFormChangeAlt(e, "subCheckNo", mafSubQuestions?.itemId, member?.memberId)}
                                                                                            />
                                                                                            <label className="form-check-label" for={mafSubQuestions?.itemId + "subCheckNo" + member?.memberId}>No</label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {/*SUB SUB QUESTIONS*/
                                                                                mafAnswers?.find(p => p?.itemId == mafSubQuestions?.itemId)?.memberIdList?.find(f => f == member?.memberId) && (medicalApplicationForm.mafQuestions.filter((e) => e.parentId === mafSubQuestions.itemId && e.isSubItem === "Y").length != 0 ? true : false) &&
                                                                                <div className="row g-2">
                                                                                    <div className="m-2 col-11 alert alert-secondary fade show" >
                                                                                        {medicalApplicationForm.mafQuestions.filter((e) => e.parentId === mafSubQuestions.itemId && e.isSubItem === "Y").map((mafSubSubQuestions/*, index*/) => (

                                                                                            <div key={mafSubSubQuestions.itemId} >
                                                                                                <div className="row g-2 ">
                                                                                                    <div className="col-md-6">
                                                                                                        <h5> <i className='mdi mdi-arrow-right-bold me-2'></i>{mafSubSubQuestions.questionsInEnglish}</h5>
                                                                                                    </div>
                                                                                                    <div className="col-md-4">
                                                                                                    </div>
                                                                                                    {mafSubSubQuestions.attributes.map((mafQuestionsAttributes/*, index*/) => (
                                                                                                        (mafQuestionsAttributes.itemTypeId == 2) &&
                                                                                                        <div className="col-md-2">
                                                                                                            <div className="row g-2">
                                                                                                                <div className="form-check m-2 mt-3 col-md-3">
                                                                                                                    <input
                                                                                                                        type="radio"

                                                                                                                        id={mafSubSubQuestions.itemId + "Radio" + member?.memberId}
                                                                                                                        name={mafSubSubQuestions.itemId + "Radio" + member?.memberId}
                                                                                                                        className={errorsShortMedicalForm.hasOwnProperty(`${mafSubSubQuestions.itemId}` + "SubSubQuestion") && mafSubSubQuestions.isApplicable === null ? 'form-check-input is-invalid' : 'form-check-input'}
                                                                                                                        onChange={e => handleMedicalFormChangeAlt(e, "Radio", mafSubSubQuestions.itemId, member?.memberId)}
                                                                                                                        checked={mafAnswers?.find(p => p?.itemId == mafSubSubQuestions?.itemId)?.memberIdList.find(v => v == member?.memberId)}
                                                                                                                    />
                                                                                                                    <label className="form-check-label " for={mafSubSubQuestions.itemId + "Radio" + member?.memberId}>Yes</label>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                            </div>

                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>

                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }

                                                        {/*  */}
                                                    </>}
                                                </>))}
                                            </div>
                                        }
                                        {/* medicalApplicationForm?.isDateSelectedYn == "Y" &&  */}
                                        {mafQuestions?.itemId == Constants.MAF_ITEM_ID_59 && LMPApplList?.length > 0 &&
                                            <>
                                                <div className="col-md-10">
                                                    <h5> {mafQuestions.orderId}.&nbsp;&nbsp;{mafQuestions.questionsInEnglish}</h5>
                                                </div>
                                                < div className="m-2 col-8 alert alert-primary fade show" >{memberBasicInfo?.memberList?.map((member, index) => (
                                                    <>
                                                        {((mafQuestions?.itemId == Constants.MAF_ITEM_ID_41 || mafQuestions?.itemId == Constants.MAF_ITEM_ID_45 || mafQuestions?.itemId == Constants.MAF_ITEM_ID_59) ? member?.memberGender == Constants.FEMALE_DOMAIN_ID_ID && member?.relation != appConstants.RELATION_CHILDREN_ID : true) && <>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-3" id="Check1">
                                                                    <input //className="form-control date"
                                                                        className={/* errorsShortMedicalForm.hasOwnProperty(`${mafQuestions.itemId}` + "RemarkDate" + member?.memberId) *//*  && mafQuestions.isApplicable === null */ (!mafDateAnswers?.find(pod => pod?.memberId == member?.memberId) && medicalApplicationForm?.saveAttempted == true) ? 'form-control is-invalid' : 'form-control'}
                                                                        type="date"
                                                                        disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                                        max={appUtility.formatDate(appConstants.TODAY)}
                                                                        id={mafQuestions?.attributes?.attributeId}
                                                                        name={mafQuestions.itemId + "RemarkDate"}
                                                                        placeholder="Enter LMP Date"
                                                                        {...registerShortMedicalForm(`${mafQuestions.itemId}` + "RemarkDate" + member?.memberId, { required: true, onChange: (e) => handleMedicalFormChange(e) })}
                                                                        value={mafDateAnswers?.find(a => a?.memberId == member?.memberId)?.date ?? ""}
                                                                    />
                                                                    {(!mafDateAnswers?.find(pod => pod?.memberId == member?.memberId) && medicalApplicationForm?.saveAttempted == true) && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                                                </div>
                                                                <div className="col-md-7">{member?.memberFullName}</div>
                                                                <div className="col-md-2 text-end">{masters?.relationMasters?.find(p => p?.id == member?.relation)?.name ?? ""}</div>
                                                            </div>
                                                        </>}
                                                    </>))}
                                                </div>
                                            </>
                                        }

                                    </div>
                                ))}
                    </div>
                    <ul className="nav nav-tabs nav-bordered mb-3">
                    </ul>
                    {
                        mafQuestions?.length > 0 &&
                        <small>
                            <span className='text-danger fst-italic fs-6'>*Chronic Diseases:</span>
                            <br />
                            <p style={{ textAlign: 'justify', textJustify: 'inter-word' }} className='fst-italic fs-6'>
                                &gt; A disease with one or more of the following characteristics: lasts 3 months or more, leaves residual disability, is caused by non-reversible pathological alteration, requires special
                                training of the patient for rehabilitation, or may require a long period of supervision, observation, or case.
                                <br />
                                {/* &gt; In case the answer is <span style={{ color: '#228B22', fontWeight: 'bold' }}>YES</span> to any of the conditions/diseases above, please specify full details on additional questionnaire attached to this application form. */}
                            </p >
                            <p style={{ textAlign: 'justify', textJustify: 'inter-word' }} className='text-danger fst-italic fs-6'>
                                Disclaimer:
                                <br />
                                I understand and acknowledge any pregnancy not declared at the time of this application’s coverage will be at the sole discretion of the insurer. The insurer has the right to not
                                cover any maternity claims to any undeclared pregnancy. I also acknowledge and understand any pregnancy, which arises within forty calendar days from the date of this
                                application; coverage will also be at the discretion of the insurer.
                            </p>
                        </small>
                    }

                </form >
            </div >
        </>
        )
    }
    return (<>
        <div className="row" ref={refShortQuestionaire}>
            {renderShortMedicalForm()}
        </div>
    </>);
}